import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';
import { createEntity, getEntity, reset, updateEntity } from './ethnic-group.reducer';

export const EthnicGroupUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const ethnicGroupEntity = useAppSelector(state => state.ethnicGroup.entity);
  const loading = useAppSelector(state => state.ethnicGroup.loading);
  const updating = useAppSelector(state => state.ethnicGroup.updating);
  const updateSuccess = useAppSelector(state => state.ethnicGroup.updateSuccess);
  const geographicLevelValues = Object.keys(GeographicLevel);

  const handleClose = () => {
    navigate(`/ethnic-group${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.totalAllUsualResidents !== undefined && typeof values.totalAllUsualResidents !== 'number') {
      values.totalAllUsualResidents = Number(values.totalAllUsualResidents);
    }
    if (values.asian !== undefined && typeof values.asian !== 'number') {
      values.asian = Number(values.asian);
    }
    if (values.black !== undefined && typeof values.black !== 'number') {
      values.black = Number(values.black);
    }
    if (values.mixed !== undefined && typeof values.mixed !== 'number') {
      values.mixed = Number(values.mixed);
    }
    if (values.white !== undefined && typeof values.white !== 'number') {
      values.white = Number(values.white);
    }
    if (values.otherEthnicGroup !== undefined && typeof values.otherEthnicGroup !== 'number') {
      values.otherEthnicGroup = Number(values.otherEthnicGroup);
    }

    const entity = {
      ...ethnicGroupEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          geographicLevel: 'EXTRA_WARD',
          ...ethnicGroupEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="apiLocationApp.ethnicGroup.home.createOrEditLabel" data-cy="EthnicGroupCreateUpdateHeading">
            <Translate contentKey="apiLocationApp.ethnicGroup.home.createOrEditLabel">Create or edit a EthnicGroup</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="ethnic-group-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('apiLocationApp.ethnicGroup.geographicLevel')}
                id="ethnic-group-geographicLevel"
                name="geographicLevel"
                data-cy="geographicLevel"
                type="select"
              >
                {geographicLevelValues.map(geographicLevel => (
                  <option value={geographicLevel} key={geographicLevel}>
                    {translate(`apiLocationApp.GeographicLevel.${geographicLevel}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('apiLocationApp.ethnicGroup.date')}
                id="ethnic-group-date"
                name="date"
                data-cy="date"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.ethnicGroup.geography')}
                id="ethnic-group-geography"
                name="geography"
                data-cy="geography"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.ethnicGroup.geographyCode')}
                id="ethnic-group-geographyCode"
                name="geographyCode"
                data-cy="geographyCode"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.ethnicGroup.totalAllUsualResidents')}
                id="ethnic-group-totalAllUsualResidents"
                name="totalAllUsualResidents"
                data-cy="totalAllUsualResidents"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.ethnicGroup.asian')}
                id="ethnic-group-asian"
                name="asian"
                data-cy="asian"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.ethnicGroup.black')}
                id="ethnic-group-black"
                name="black"
                data-cy="black"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.ethnicGroup.mixed')}
                id="ethnic-group-mixed"
                name="mixed"
                data-cy="mixed"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.ethnicGroup.white')}
                id="ethnic-group-white"
                name="white"
                data-cy="white"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.ethnicGroup.otherEthnicGroup')}
                id="ethnic-group-otherEthnicGroup"
                name="otherEthnicGroup"
                data-cy="otherEthnicGroup"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/ethnic-group" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default EthnicGroupUpdate;
